"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listTrim = void 0;
const listTrim = (list, field = 'title') => {
    return (list === null || list === void 0 ? void 0 : list.length)
        ? list.length === 1
            ? list[0][field]
            : `${list[0][field]} +${list.length - 1}`
        : '';
};
exports.listTrim = listTrim;
exports.default = exports.listTrim;
